import React from "react";
import SharedResultPage from "./SharedResultPage";

/**
 * Current result page. Renders the shared result UI with live result data.
 */
export default function Result() {
  return <SharedResultPage isPreviousResult={false} />;
}
